$(document).ready(function(){

  $('.m-menu').click(function(){
  	if($('body').hasClass('m-menu-open')){
  		$('html, body').removeClass('noscroll');
    	$('body').removeClass('m-menu-open');
  	}else{
  		$('html, body').addClass('noscroll');
    	$('body').addClass('m-menu-open');
  	}

  });


	// start scrolling
	// via https://codepen.io/nolanlawson/pen/yZKLLO
	// via https://github.com/tootsuite/mastodon/blob/f59ed3a4fafab776b4eeb92f805dfe1fecc17ee3/app/javascript/mastodon/scroll.js
	const easingOutQuint = (x, t, b, c, d) =>
	  c * ((t = t / d - 1) * t * t * t * t + 1) + b

	function smoothScrollPolyfill (node, key, target) {
	  const startTime = Date.now()
	  const offset = node[key]
	  const gap = target - offset
	  const duration = 1000
	  let interrupt = false

	  const step = () => {
	    const elapsed = Date.now() - startTime
	    const percentage = elapsed / duration

	    if (interrupt) {
	      return
	    }

	    if (percentage > 1) {
	      cleanup()
	      return
	    }

	    node[key] = easingOutQuint(0, elapsed, offset, gap, duration)
	    requestAnimationFrame(step)
	  }

	  const cancel = () => {
	    interrupt = true
	    cleanup()
	  }

	  const cleanup = () => {
	    node.removeEventListener('wheel', cancel)
	    node.removeEventListener('touchstart', cancel)
	  }

	  node.addEventListener('wheel', cancel, { passive: true })
	  node.addEventListener('touchstart', cancel, { passive: true })

	  step()

	  return cancel
	}

	function testSupportsSmoothScroll () {
	  let supports = false
	  try {
	    let div = document.createElement('div')
	    div.scrollTo({
	      top: 0,
	      get behavior () {
	        supports = true
	        return 'smooth'
	      }
	    })
	  } catch (err) {} // Edge throws an error
	  return supports
	}

	function smoothScroll (node, topOrLeft, horizontal) {
	  if (hasNativeSmoothScroll) {
	  	//console.log('has smooth scroll')
	  	return node.scrollTo({
	      [horizontal ? 'left' : 'top']: topOrLeft,
	      behavior: 'smooth'
	    })
	  } else {
	  	//console.log('no smooth scroll')
	  	return smoothScrollPolyfill(node, horizontal ? 'scrollLeft' : 'scrollTop', topOrLeft)
	  }
	}

	function debounce(func, ms) {
		let timeout
		return () => {
			clearTimeout(timeout)
			timeout = setTimeout(() => {
				timeout = null
	      func()
			}, ms)
		}
	}

	const hasNativeSmoothScroll = testSupportsSmoothScroll()
	const indicators = document.querySelectorAll('.dot')
	const scroller = document.querySelector('.right')

	function setAriaLabels() {
		// console.log('setting labels')
		const indicators = document.querySelectorAll('.dot')
		const scroller = document.querySelector('.right')
	  indicators.forEach((indicator, i) => {
	  	var projpos = Math.floor($('.project').eq(i).offset().top - 200);

	  	if($('.home .right').position().top == 40){
	  		projpos -= 40;
	  	}
	  	indicator.setAttribute('aria-label', `Scroll to item #${i + 1}`)
	    indicator.setAttribute('data-pos', projpos)
	  })
	  // setAriaPressed(0);
	}

	function setAriaPressed(index) {
		// console.log('arai pressed: ' + index);
	  indicators.forEach((indicator, i) => {
	    indicator.setAttribute('aria-pressed', !!(i === index))
	  })
	}


	function initHomePage(){
		const indicators = document.querySelectorAll('.dot')
		const scroller = document.querySelector('.right')
		// console.log('init homepage',indicators,scroller)
		indicators.forEach((indicator, i) => {
		  indicator.addEventListener('click', e => {
		    e.preventDefault()
		    e.stopPropagation()
		    setAriaPressed(i)
		    var newpos = $('.project').eq(i).offset().top - 200;
		    const scrollTop = Math.floor(newpos)
		    smoothScroll(scroller, (scroller.scrollTop +scrollTop), false);
		    // console.log('click')
		  })
		})

		scroller.addEventListener('scroll', debounce(() => {
			// console.log("finished on: " + scroller.scrollTop)
		 	$(".dot").attr('aria-pressed', false)
		 	$(".dots").find("[data-pos='" + scroller.scrollTop + "']").attr('aria-pressed', true)
		}, 500))

		setAriaLabels();

		//setTimeout(resetScroll, 500);

		// listen to keys
		document.onkeydown = checkKey;

		growLastProject();
		$('#pcontainer').scrollTop(0);

	}

	function resetScroll(){
		if($('body').hasClass('home')){
			smoothScroll(scroller, 0, false);
			setTimeout(setAriaLabels, 500);
		}
		growLastProject();
	}

	function checkKey(e) {
    e = e || window.event;
    if (e.keyCode == '38') { // up arrow
      scrollUp();
    }
    else if (e.keyCode == '40') { // down arrow
      scrollDown();
    }
	}

	function scrollUp(){
		//console.log('scrollup')
		var curr = $("[aria-pressed=true]");
		var prev = curr.prev('.dot');
		prev.click();
	}
	function scrollDown(){
		//console.log('scrolldown')
		var curr = $("[aria-pressed=true]");
		var next = curr.next('.dot');
		next.click();
	}

	// end scrolling
	window.onresize = resetScroll;


	// Enlarge the last item so we can scroll it to the top of the container
	function growLastProject(){
		// console.log('grow last project')
		var newProjHeight = $(window).height() - $('.header').height() - $('.project:last-child').height() + 'px';
		var newSlideHeight = $(window).height() - $('.header').height() - $('.slide:last-child').height() + 'px';
		$('.project:last-child').css({paddingBottom:newProjHeight})
		if($('body').hasClass('fp-responsive')){
			$('.slide:last-child').css({paddingBottom:newSlideHeight})
		}
	}


	function initProjectDetail(){
		// //methods
		// $.fn.fullpage.setAllowScrolling(false);

		// console.log(fullpage)
		// console.log('create fullpage');
		new fullpage('#fullpage', {
			//options here
			licenseKey: 'C42BCB8E-06D2480A-83B67F22-E6672B0E',
			autoScrolling:true,
			scrollHorizontally: false,
			navigation: true,
			navigationPosition: 'left',
			fixedElements: 'header.header',
			responsiveWidth: 600,
			responsiveHeight: 600
			// showActiveTooltip: true
		});

		//methods
		// fullpage_api.setAllowScrolling(false);

		$('.slide .linked	').mouseover(function(){
			$('.slide.active').addClass('alive')
		}).mouseout(function(){
			$('.slide.active').removeClass('alive')
		})

		$('.linked').click(function(){
			//console.log('hellow')
			// $('.slide.active').toggleClass('open-img')
		})

		growLastProject();
	}


	// TOGETHER PAGE
	function getCarouselPositions() {
	  carouselPositions = [];
	  document.querySelectorAll('#todos > div').forEach(function(div) {
	    carouselPositions.push([div.offsetTop, div.offsetTop + div.offsetHeight]); // add to array the positions information
	  })
	  // console.log(carouselPositions)
	}
	function goCarousel(direction) {
			var currentScrollTop = document.querySelector('#todos').scrollTop;
		  var currentScrollBottom = currentScrollTop + document.querySelector('#todos').offsetHeight;

		  if (currentScrollTop === 0) {
		  	//console.log('first')
		  	if (direction === 'next') {
					currentItem = 1;
				}else{
					return
				}
		  }
		  else {

		      if (direction === 'next') {
		      	for (var i = 0; i < carouselPositions.length; i++) {
		      		if(carouselPositions[i][0] > currentScrollTop){
		      			currentItem=i+1;
		      			break;
		      		}
		      	}

		      }else{
		      	for (var i = currentItem; i > 0; i--) {
		      		if(carouselPositions[i][0] < currentScrollTop){
		      			currentItem = i-1;
		      			break;
		      		}
		      	}
		      }

		  }
			// console.log('current: ' + currentItem)
		  document.getElementById('todos').scrollTo({
		    top: carouselPositions[currentItem][0],
		    behavior: 'smooth'
		  });

		}


	function initTogetherPage(){
		//console.log('inittotgetherpage')
		$('.stadsform .gallery').slick({
			centerMode: true,
  		slidesToShow: 1,
  		centerPadding: '15%',
  		infinite:true,
  		init: initSlider()
		});
		$('.more').click(function(){
			$(this).parent().toggleClass('open')
		})

		$('.s1 button').click(function(e){
			e.preventDefault();
			if($('#endeavour').val() != ''){
				$('.s1').hide();
				$('.s2').addClass('show');
			}
		})

		// start scroll
		$("#todos").attr("tabindex",-1).focus();
		var carouselPositions;
		var halfContainer;
		var currentItem;

		getCarouselPositions(); // call it once

		window.addEventListener('resize', getCarouselPositions);
		// end scroll
		document.onkeydown = checkMyKey;
	}

	function checkMyKey(e) {
    e = e || window.event;
    if (e.keyCode == '38') { // up arrow
      goCarousel('previous')
    }
    else if (e.keyCode == '40') { // down arrow
      goCarousel('next')
    }
	}

	function initSlider(){
		$('.vid').fitVids();
	}


	// Discover map
	function initMap(data){
		const bxl = { lat: 50.84673, lng: 4.35247 };

		const map = new google.maps.Map(document.getElementById("map"), {
		  zoom: 7,
		  center: bxl,
		  mapId: 'e506402436e47f1a',
		  disableDefaultUI: true,
		});

	 var projs = JSON.parse(data)
	 var infowindow = new google.maps.InfoWindow()
	 for (var i = 0; i < projs.length; i++) {
		 	var marker = new google.maps.Marker({
			  position: {lat:projs[i]['lat'], lng:projs[i]['long']},
			  map: map,
			  icon: '/img/dot.svg'
			});

			var content = '<div class="e-popup"><a href="'+ projs[i]['url']+'">' + projs[i]['txt'] + '</a></div>';

			google.maps.event.addListener(marker,'click', (function(marker,content,infowindow){
	      return function() {
	         infowindow.setContent(content);
	         infowindow.open(map,marker);
	      };
	    })(marker,content,infowindow));

		}
		// console.log('initmap');
		$('#m-filter').click(function(){
			$('.filter-type').toggle();
			$('#filter-all').toggle();
			setContentPadding();
		});
		$('#d-filter').click(function(){
			$('.filter-type').toggle();
			$('#filter-all').toggle();
			setContentPadding();
			$(this).toggle();
		});

	}

	// Ongoing
	function initOngoing(){
		$('.blocks .gallery').slick({
			centerMode: true,
  		slidesToShow: 1,
  		centerPadding: '15%',
  		infinite:true,
  		init: initSlider()
		});
	}

	// Services
	function initServices(){
		$('html').scrollTop(0);
		$('.block.service').click(function(){
			$(this).toggleClass('open');
		})
	}

	// General
	function initGeneral(){
		$('html').scrollTop(0);
	}


	// Contact
	function initContact() {
		$('html').scrollTop(0);
		const antwerp = { lat: 51.2147636, lng: 4.4053285};
		const map = new google.maps.Map(document.getElementById("map"), {
		  zoom: 15,
		  center: antwerp,
		  mapId: 'e506402436e47f1a',
		  disableDefaultUI: true,
		});
		var marker = new google.maps.Marker({
			  position: {lat:51.2147636, lng:4.4053285},
			  map: map,
			  icon: {
			  	url:'/img/dot.svg',
			  	scaledSize: new google.maps.Size(25, 25), // scaled size
				}
			});
	}

	// Adapt content padding on filters' height
	function initProjects(){
		//console.log('init projects');
		window.onresize = setContentPadding;
		setContentPadding();
		$('#m-filter').click(function(){
			$('.filter-type').toggle();
			$('#filter-all').toggle();
			setContentPadding();
		});
		$('#d-filter').click(function(){
			$('.filter-type').toggle();
			$('#filter-all').toggle();
			setContentPadding();
			$(this).toggle();
		});

		$('html').scrollTop(0);

	}
	function setContentPadding(){
		// console.log('set content padding');
		var pt = $('.header').height() + $('.filters').height() + 20;
		$('body').find('.main').css({'padding-top':pt+'px'})
	}



	// page transitions
	barba.use(barbaCss);

	barba.hooks.afterLeave((data) => {
		//console.log('after leave ', data.current.container)
		const curr = data.current.container;
		var prevBodyClass = $(curr).find('.content').attr('data-bodyclass')
		// console.log('previous page: ' + prevBodyClass)
		if(prevBodyClass == 'project-detail'){
			// console.log('destroy fullpage')
			fullpage_api.destroy('all');
		}

		// update the language switch
		var newLangSwitchHTML = $(data.next.html).find('.lang-switch').html();
		$('.lang-switch').html(newLangSwitchHTML)
		var newNavHTML = $(data.next.html).find('.nav__container').html();
		$('.nav__container').html(newNavHTML);
		var newLogoURL = $(data.next.html).find('.logo a').attr('href');
		$('.logo a').attr('href',newLogoURL);

	});

	barba.hooks.beforeEnter((data) => {
		//console.log('before enter')
		const curr = data.next.container;
		var newBodyClass = $(curr).find('.content').attr('data-bodyclass')
		$('body').removeClass().addClass(newBodyClass);
		// console.log(newBodyClass)
		if(newBodyClass == 'discover gmap' || newBodyClass == 'projects gmap'){
			var data = $(curr).find('#dataholder').attr('data-projects')
			initMap(data);
		}
	});

	barba.hooks.enter((data) => {
		const curr = data.next.container;
		//console.log('enter',curr)
		var newBodyClass = $(curr).find('.content').attr('data-bodyclass')
		$('body').removeClass().addClass(newBodyClass)
		$('html, body').removeClass('noscroll');
    $('body').removeClass('m-menu-open');
		if(newBodyClass == 'home'){
			initHomePage();
		}
		if(newBodyClass == 'together'){
			initTogetherPage();
		}
		if(newBodyClass == 'project-detail'){
			initProjectDetail();
		}
		if(newBodyClass == 'ongoing'){
			initOngoing();
		}
		if(newBodyClass == 'contact'){
			initContact();
		}
		if(newBodyClass == 'projects'){
			initProjects();
		}
		if(newBodyClass == 'services'){
			initServices();
		}
		if(newBodyClass == 'knowledge' || newBodyClass == 'ventures'){
			initGeneral();
		}
	});
	barba.hooks.once((data) => {
		const curr = data.next.container;
		//console.log('once',curr)
		var newBodyClass = $(curr).find('.content').attr('data-bodyclass')
		$('body').removeClass().addClass(newBodyClass)
		if(newBodyClass == 'home'){
			initHomePage();
		}
		if(newBodyClass == 'together'){
			initTogetherPage();
		}
		if(newBodyClass == 'project-detail'){
			initProjectDetail();
		}
		if(newBodyClass == 'ongoing'){
			initOngoing();
		}
		if(newBodyClass == 'contact'){
			initContact();
		}
		if(newBodyClass == 'projects'){
			initProjects();
		}
		if(newBodyClass == 'services'){
			initServices();
		}
		if(newBodyClass == 'knowledge' || newBodyClass == 'ventures'){
			initGeneral();
		}
	});

	var pageOrder = {
		homepage:1,
		projects:2,
		services:3,
		ventures:4,
		knowledge:5,
		trainings:6,
		cooperative:7,
		contact:8
	}
	hasFullPage = false;
	barba.init({
		sync: true,
	  transitions: [{
	    name: 'slide',
	    from: {
	      custom: ({ current }) => {
	      	var fromPage = $(current.container).find('.content').attr('data-bodyclass');
        	if(fromPage == 'discover'){
        		return true;
        	}
        	return false;
      	},
	    },
	    to: {
	      custom: ({ next }) => {
	      	var toPage = $(next.container).find('.content').attr('data-bodyclass');
        	if(toPage == 'home'){
        		return true;
        	}
        	return false;
      	},
	    },
	    once(){},
	    leave() {},
	    enter() {}
	  },
	  {
	    name: 'slide',
	    from: {
	      custom: ({ current }) => {
	      	var fromPage = $(current.container).find('.content').attr('data-bodyclass');
        	if(fromPage == 'together'){
        		return true;
        	}
        	return false;
      	},
	    },
	    to: {
	      custom: ({ next }) => {
	      	var toPage = $(next.container).find('.content').attr('data-bodyclass');
        	if(toPage == 'home'){
        		return true;
        	}
        	return false;
      	},
	    },
	    once(){},
	    leave() {},
	    enter() {}
	  },
	  {
	    name: 'slide',
	    from: {
	      custom: ({ current }) => {
	      	var fromPage = $(current.container).find('.content').attr('data-bodyclass');
        	if(fromPage == 'together'){
        		return true;
        	}
        	return false;
      	},
	    },
	    to: {
	      custom: ({ next }) => {
	      	var toPage = $(next.container).find('.content').attr('data-bodyclass');
        	if(toPage == 'discover'){
        		return true;
        	}
        	return false;
      	},
	    },
	    once(){},
	    leave() {},
	    enter() {}
	  },
	  {
	    name: 'slide-left',
	    from: {
	      custom: ({ current }) => {
	      	var fromPage = $(current.container).find('.content').attr('data-bodyclass');
        	if(fromPage == 'discover'){
        		return true;
        	}
        	return false;
      	},
	    },
	    to: {
	      custom: ({ next }) => {
	      	var toPage = $(next.container).find('.content').attr('data-bodyclass');
        	if(toPage == 'together'){
        		return true;
        	}
        	return false;
      	},
	    },
	    once(){},
	    leave() {},
	    enter() {}
	  },
	  {
	    name: 'slide-left',
	    from: {
	      custom: ({ current }) => {
	      	var fromPage = $(current.container).find('.content').attr('data-bodyclass');
        	if(fromPage == 'home'){
        		return true;
        	}
        	return false;
      	},
	    },
	    to: {
	      custom: ({ next }) => {
	      	var toPage = $(next.container).find('.content').attr('data-bodyclass');
        	if(toPage == 'together'){
        		return true;
        	}
        	return false;
      	},
	    },
	    once(){},
	    leave() {},
	    enter() {}
	  },
	  {
	    name: 'slide-left',
	    from: {
	      custom: ({ current }) => {
	      	var fromPage = $(current.container).find('.content').attr('data-bodyclass');
        	if(fromPage == 'home'){
        		return true;
        	}
        	return false;
      	},
	    },
	    to: {
	      custom: ({ next }) => {
	      	var toPage = $(next.container).find('.content').attr('data-bodyclass');
        	if(toPage == 'discover'){
        		return true;
        	}
        	return false;
      	},
	    },
	    once(){},
	    leave() {},
	    enter() {}
	  },
	  {
	    name: 'slide-left',
	    from: {
	      custom: ({ current,next }) => {
	      	var fromPage = $(current.container).find('.content').attr('data-bodyclass');
	      	var toPage = $(next.container).find('.content').attr('data-bodyclass');
        	if(pageOrder !== undefined && (pageOrder[fromPage] < pageOrder[toPage])){
        		return true;
        	}
        	return false;
      	},
	    },
	    once(){},
	    leave() {},
	    enter() {}
	  },
	  {
	    name: 'slide',
	    from: {
	      custom: ({ current,next }) => {
	      	var fromPage = $(current.container).find('.content').attr('data-bodyclass');
	      	var toPage = $(next.container).find('.content').attr('data-bodyclass');
        	if(pageOrder !== undefined && (pageOrder[fromPage] > pageOrder[toPage])){
        		return true;
        	}
        	return false;
      	},
	    },
	    once(){},
	    leave() {},
	    enter() {}
	  }]
	})

});